import { DataProxy } from '@apollo/client';

import { GetLoggedInUserQuery, GetLoggedInUserQueryVariables, PlexOverviewFragment } from '../gen/types';
import { GET_LOGGED_IN_USER_QUERY } from '../queries/GetLoggedInUser';

export function prependPlexToUserPlexesCache(
  proxy: DataProxy,
  {
    plex,
  }: {
    plex: PlexOverviewFragment;
  }
): void {
  const queryKey = {
    query: GET_LOGGED_IN_USER_QUERY,
    variables: {},
  };

  try {
    const existingData = proxy.readQuery<GetLoggedInUserQuery, GetLoggedInUserQueryVariables>(queryKey);

    if (existingData?.currentUser?.plexes != null && !existingData.currentUser?.plexes.find((p) => p.id === plex.id)) {
      proxy.writeQuery<GetLoggedInUserQuery, GetLoggedInUserQueryVariables>({
        ...queryKey,
        data: {
          ...existingData,
          currentUser: {
            ...existingData.currentUser,
            plexes: [plex, ...existingData.currentUser.plexes],
          },
        },
      });
    }
  } catch (e) {
    console.warn(e);
    // Nothing to do, exception from `readQuery` means data was not available in cache
  }
}
